import React, { useState, useEffect, useContext } from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ChatList from './ChatList';
import { withCookies } from 'react-cookie';
import { isAuthenticated } from '@actions/authentication';
import { RenewToken } from '@utils/token';
import { ChatContext } from '@/ChatProvider';
import styles from '@styles/chat.module.css';

export function Chat(props) {

    const { setIsAuthenticated } = useContext(ChatContext);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        handleTitle();
        resizePage();
        handleToken();
    }, []);

    const handleTitle = () => {
        if (props.onLoadTitle != null) {
            props.onLoadTitle(i18next.t('menu:chat'));
        }
    }

    const resizePage = () => {
        setTimeout(() => {
            const heightWindow = window.innerHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;
            const customHeight = heightWindow - menu - offSet;

            const element = document.querySelector("#divChatList");
            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }

    const handleToken = async () => {
        await RenewToken(props);

        isAuthenticated().then((result) => {
            setAuthenticated(result);
            setIsAuthenticated(result);
        });
    }

    return (
        authenticated && <div id="divChatList" className={styles.konekCard} style={{ zIndex: '1'}}>
            <ChatList/>
        </div>
    );
}

export default withNamespaces(['menu', 'chat', 'common', 'error'], { wait: true })(withCookies(Chat));